import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../../interfaces";
import {
  GET_STUDENTS,
  GET_STUDENTS_V2,
  GetStudentsAction,
  GetStudentsV2Action,
} from "./actionTypes";
import {
  getStudentsError,
  getStudentsSuccess,
  getStudentsV2Error,
  getStudentsV2Success,
} from "./actions";
import { getStudents, getStudentsV2 } from "../../../helpers/backend_helper";

function* getStudentsSaga({ payload: { request } }: GetStudentsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getStudents,
      request as PaginateQuery
    );
    yield put(getStudentsSuccess(response.data));
  } catch (error) {
    yield put(getStudentsError(error));
  }
}

function* getStudentsV2Saga({ payload: { request } }: GetStudentsV2Action) {
  try {
    const response: ResponseGenerator = yield call(
      getStudentsV2,
      request as PaginateQuery
    );
    yield put(getStudentsV2Success(response.data));
  } catch (error) {
    yield put(getStudentsV2Error(error));
  }
}

function* StudentsSaga() {
  yield takeEvery(GET_STUDENTS, getStudentsSaga);
  yield takeEvery(GET_STUDENTS_V2, getStudentsV2Saga);
}

export default StudentsSaga;
